import { CandidateTimestampToggle } from '../../../components/candidate-timestamp-toggle'
import { CandidateAttributesToggle } from '../../../components/candidate-attributes-toggle'
import { CandidatePhoneToggle } from '../../../components/candidate-phone-toggle'
import { Button, Flex, Tooltip } from 'antd'
import { Link } from '@tanstack/react-router'
import { ContainerOutlined, ExpandOutlined, PlusOutlined, ShrinkOutlined, UploadOutlined } from '@ant-design/icons'
import { CandidateArchiveButton } from '../../../candidate/components/candidate-archive-button'
import React from 'react'
import { Campaign } from '../../campaign'
import { useTranslation } from 'react-i18next'

export function Toolbar({
    fullscreen = false,
    campaign,
    selected,
    setSelected,
}: {
    fullscreen?: boolean
    campaign: Campaign
    selected: Record<string, boolean>
    setSelected: (selected: Record<string, boolean>) => void
}) {
    const { t } = useTranslation()

    return (
        <Flex align="center">
            <CandidateTimestampToggle />
            <CandidateAttributesToggle />
            <CandidatePhoneToggle />
            {fullscreen ? (
                <Tooltip title={t('Close fullscreen')}>
                    <Link
                        to="/campaigns/$campaignId/board"
                        params={{ campaignId: campaign.id }}
                    >
                        <Button
                            type="text"
                            icon={<ShrinkOutlined />}
                        />
                    </Link>
                </Tooltip>
            ) : (
                <Tooltip title={t('Fullscreen')}>
                    <Link
                        to="/campaigns/$campaignId/full-board"
                        params={{ campaignId: campaign.id }}
                    >
                        <Button
                            type="text"
                            icon={<ExpandOutlined />}
                        />
                    </Link>
                </Tooltip>
            )}

            <Tooltip title={t('Add candidate')}>
                <Link
                    to="."
                    search={{
                        create: true,
                    }}
                >
                    <Button
                        type="text"
                        icon={<PlusOutlined />}
                        disabled={campaign.status !== 'active'}
                    />
                </Link>
            </Tooltip>
            <Tooltip title={t('Import candidates from CSV or Excel file')}>
                <Link
                    to="."
                    search={{
                        bulk: true,
                    }}
                >
                    <Button
                        type="text"
                        icon={<UploadOutlined />}
                        disabled={campaign.status !== 'active'}
                    />
                </Link>
            </Tooltip>
            <Tooltip title={t('Archive')}>
                <Link
                    to="."
                    search={{
                        archive: true,
                    }}
                >
                    <Button
                        type="text"
                        icon={<ContainerOutlined />}
                    />
                </Link>
            </Tooltip>
            {Object.keys(selected).length > 0 && (
                <CandidateArchiveButton
                    onSuccess={() => setSelected({})}
                    candidateIds={Object.keys(selected)}
                />
            )}
        </Flex>
    )
}
